// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/black-box.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/black-box-768.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/black-box-414.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-black {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: contain;
  position: relative;
}
@media screen and (max-width: 768px) {
  .container-black {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}
@media screen and (max-width: 414px) {
  .container-black {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
}
.container-black.home-page {
  margin-top: -154px;
}
@media screen and (max-width: 1440px) {
  .container-black.home-page {
    margin-top: -125px;
  }
}
@media screen and (max-width: 1024px) {
  .container-black.home-page {
    margin-top: -125px;
  }
}
@media screen and (max-width: 768px) {
  .container-black.home-page {
    margin-top: -30px;
  }
}
@media screen and (max-width: 414px) {
  .container-black.home-page {
    margin-top: -65px;
  }
}
.container-black.about-page {
  margin-top: -10%;
  position: relative;
  z-index: 5;
}
@media screen and (max-width: 1710px) {
  .container-black.about-page {
    margin-top: -154px;
  }
}
@media screen and (max-width: 1440px) {
  .container-black.about-page {
    margin-top: -132px;
  }
}
@media screen and (max-width: 1024px) {
  .container-black.about-page {
    margin-top: -125px;
  }
}
@media screen and (max-width: 768px) {
  .container-black.about-page {
    margin-top: -45px;
  }
}
@media screen and (max-width: 414px) {
  .container-black.about-page {
    margin-top: -65px;
  }
}
.container-black_list {
  display: flex;
  justify-content: space-evenly;
  padding-top: 147px;
  color: #fff;
  padding: 13% 15% 15%;
  align-items: flex-end;
}
@media screen and (max-width: 1440px) {
  .container-black_list {
    padding: 12% 10% 13%;
  }
}
@media screen and (max-width: 1300px) {
  .container-black_list {
    padding: 11% 13% 14%;
  }
}
@media screen and (max-width: 1200px) {
  .container-black_list {
    padding: 11% 13% 13%;
  }
}
@media screen and (max-width: 768px) {
  .container-black_list {
    padding: 8% 12% 13%;
    justify-content: space-between;
  }
}
@media screen and (max-width: 535px) {
  .container-black_list {
    padding: 4% 9% 13.1%;
  }
}
@media screen and (max-width: 414px) {
  .container-black_list {
    padding: 8% 16% 13%;
  }
}
.container-black_list div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
}
@media screen and (max-width: 500px) {
  .container-black_list div {
    gap: 0px;
  }
}
.container-black_list p {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: center;
}
@media screen and (max-width: 768px) {
  .container-black_list p {
    font-size: 16px;
    line-height: 25.6px;
  }
}
@media screen and (max-width: 535px) {
  .container-black_list p {
    margin: 0px;
    font-size: 14px;
    line-height: 20.6px;
  }
}
@media screen and (max-width: 414px) {
  .container-black_list p {
    text-align: center;
    font-size: 14px;
    line-height: 19.6px;
    margin: 14px 0px;
  }
}
@media screen and (max-width: 280px) {
  .container-black_list p {
    padding: 8% 12% 0%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/AboutBlackList.scss"],"names":[],"mappings":"AACA;EACI,6DAAA;EACA,wBAAA;EACA,kBAAA;AAAJ;AACI;EAJJ;IAKQ,yDAAA;EAEN;AACF;AADI;EAPJ;IAQQ,yDAAA;EAIN;AACF;AAHI;EACI,kBAAA;AAKR;AAJQ;EAFJ;IAGQ,kBAAA;EAOV;AACF;AANQ;EALJ;IAMQ,kBAAA;EASV;AACF;AARQ;EARJ;IASQ,iBAAA;EAWV;AACF;AAVQ;EAXJ;IAYQ,iBAAA;EAaV;AACF;AAXI;EACI,gBAAA;EACA,kBAAA;EACA,UAAA;AAaR;AAZQ;EAJJ;IAKQ,kBAAA;EAeV;AACF;AAdQ;EAPJ;IAQQ,kBAAA;EAiBV;AACF;AAhBQ;EAVJ;IAWQ,kBAAA;EAmBV;AACF;AAlBQ;EAbJ;IAcQ,iBAAA;EAqBV;AACF;AApBQ;EAhBJ;IAiBQ,iBAAA;EAuBV;AACF;AApBI;EACI,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAsBR;AArBQ;EAPJ;IAQQ,oBAAA;EAwBV;AACF;AAvBQ;EAVJ;IAWQ,oBAAA;EA0BV;AACF;AAzBQ;EAbJ;IAcQ,oBAAA;EA4BV;AACF;AA3BQ;EAhBJ;IAiBQ,mBAAA;IACA,8BAAA;EA8BV;AACF;AA7BQ;EApBJ;IAqBQ,oBAAA;EAgCV;AACF;AA/BQ;EAvBJ;IAwBQ,mBAAA;EAkCV;AACF;AAhCQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAkCZ;AAjCY;EALJ;IAMQ,QAAA;EAoCd;AACF;AAjCQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAmCZ;AAlCY;EANJ;IAOQ,eAAA;IACA,mBAAA;EAqCd;AACF;AApCY;EAVJ;IAWQ,WAAA;IACA,eAAA;IACA,mBAAA;EAuCd;AACF;AAtCY;EAfJ;IAgBQ,kBAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;EAyCd;AACF;AAxCY;EArBJ;IAsBQ,kBAAA;EA2Cd;AACF","sourcesContent":["\n.container-black {\n    background: url(\"../../assets/images//black-box.png\") no-repeat;\n    background-size: contain;\n    position: relative;\n    @media screen and (max-width: 768px) {\n        background-image: url(\"../../assets/images/black-box-768.png\");\n    }\n    @media screen and (max-width: 414px) {\n        background-image: url(\"../../assets/images/black-box-414.png\");\n    }\n    &.home-page {\n        margin-top: -154px;\n        @media screen and (max-width: 1440px) {\n            margin-top: -125px;\n        }\n        @media screen and (max-width: 1024px) {\n            margin-top: -125px;\n        }\n        @media screen and (max-width: 768px) {\n            margin-top: -30px;\n        }\n        @media screen and (max-width: 414px) {\n            margin-top: -65px;\n        }\n    }\n    &.about-page {\n        margin-top: -10%;\n        position: relative;\n        z-index: 5;\n        @media screen and (max-width: 1710px) {\n            margin-top: -154px;\n        }\n        @media screen and (max-width: 1440px) {\n            margin-top: -132px;\n        }\n        @media screen and (max-width: 1024px) {\n            margin-top: -125px;\n        }\n        @media screen and (max-width: 768px) {\n            margin-top: -45px;\n        }\n        @media screen and (max-width: 414px) {\n            margin-top: -65px;\n        }\n    }\n    \n    &_list {\n        display: flex;\n        justify-content: space-evenly;\n        padding-top: 147px;\n        color: #fff;\n        padding: 13%  15% 15%;\n        align-items: flex-end;\n        @media screen and (max-width: 1440px) {\n            padding: 12% 10% 13%;\n        }\n        @media screen and (max-width: 1300px) {\n            padding: 11% 13% 14%;\n        }\n        @media screen and (max-width: 1200px) {\n            padding: 11% 13% 13%;\n        }\n        @media screen and (max-width: 768px) {\n            padding: 8% 12% 13%;\n            justify-content: space-between;\n        }\n        @media screen and (max-width: 535px) {\n            padding: 4% 9% 13.1%;\n        }\n        @media screen and (max-width: 414px) {\n            padding: 8% 16% 13%;\n        }\n    \n        div {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 25px;\n            @media screen and (max-width: 500px) {\n                gap: 0px;\n            }\n        }\n    \n        p {\n            font-size: 20px;\n            font-weight: 600;\n            line-height: 30px;\n            letter-spacing: 0em;\n            text-align: center;\n            @media screen and (max-width: 768px) {\n                font-size: 16px;\n                line-height: 25.6px;\n            }\n            @media screen and (max-width: 535px) {\n                margin: 0px;\n                font-size: 14px;\n                line-height: 20.6px;\n            }\n            @media screen and (max-width: 414px) {\n                text-align: center;\n                font-size: 14px;\n                line-height: 19.6px;\n                margin: 14px 0px;\n            }\n            @media screen and (max-width: 280px){\n                padding: 8% 12% 0%;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
